const stats = [
  { number: "4,200+", label: "Companies Formed" },
  { number: "48hrs", label: "Average Processing" },
  { number: "50", label: "States Covered" },
  { number: "99.7%", label: "Success Rate" }
];

const CompanyFormationStats = () => {
  return (
    <section className="py-16 px-4 bg-hero-gradient">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            Trusted Business Formation Partner
          </h2>
          <p className="text-lg text-white/90 max-w-2xl mx-auto">
            Our proven expertise has helped thousands of entrepreneurs start their businesses successfully.
          </p>
        </div>
        
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {stats.map((stat, index) => (
            <div key={index} className="text-center text-white">
              <div className="text-4xl md:text-5xl font-bold mb-2">{stat.number}</div>
              <div className="text-white/90 font-medium">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CompanyFormationStats;